import { useCommerceAPI } from '~/features/commerce-api/contexts';

export const useGiftCertificates = () => {
    const api = useCommerceAPI();

    const getBalance = (cardNo: string, cvc?: string) => {
        if (!api?.shopperGiftCertificates?.getGiftCertificate) {
            throw new Error('CommerceAPI is missing shopperGiftCertificates.getBalance');
        }

        return api.shopperGiftCertificates.getGiftCertificate({
            parameters: {
                gcnumber: cardNo,
                gccvv: cvc,
            },
        });
    };

    return { getBalance };
};
